import React from 'react';
import { FeedItem } from './FeedItem';
import { ActionProps, getActivityTypeInfo } from './ActivityFeed';

export const RatingAction = (props: ActionProps) => {
  const { activity } = props;
  const { objectType, rating, commentUUID } = activity;

  // user has favorited a comment
  if (objectType === 'COMMENT') {
    const {
      userDisplayName,
      object: { type },
    } = activity;
    const info = getActivityTypeInfo(activity)[type] || {};

    return (
      <FeedItem
        didWhat={`liked ${userDisplayName}'s comment about`}
        onWhat={{
          name: info.name,
          url: `${info.path}/#comment_${commentUUID?.substring(0, 6)}`,
        }}
      />
    );
  }

  const info = getActivityTypeInfo(activity)[objectType] || {};
  return (
    <FeedItem
      didWhat={`rated ${info.label}`}
      onWhat={{
        name: info.name,
        url: info.path,
      }}
      moreInfo={`a ${rating}`}
    />
  );
};
